// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"535":"login","717":"pricing","790":"forms","845":"profile","885":"remind","930":"tables"}[chunkId] || chunkId) + "." + {"10":"2641db15","535":"665ec74b","717":"f8a7ffe9","790":"2728c754","845":"b2929f00","885":"6b1532bc","930":"47bf7ef3"}[chunkId] + ".js";
};